import React, { useState } from 'react'
import HomeContainer from '../Container/HomeContainer2'
import Spinner from '../../Components/Spinner/Spinner'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { selectUserDetails } from '../../redux/homePage/homePage.selectors'
import EcecResumeContent from './EcecResumeContent'

const EcecPreviewResume = ({ user }) => {
  if (user) {
    return (
      <HomeContainer
        user={user}
        isViewAsTeacher={false}
        footer={null}
        isShowWhereby={false}
        isShowPoliceCheckWwcc={true}
        tabEcecResumeActive={true}
      >
        <EcecResumeContent user={user} isViewAsTeacher={false} />
      </HomeContainer>
    )
  }
  else return <Spinner />
}

const mapStateToProps = createStructuredSelector({
  user: selectUserDetails,
})

export default connect(mapStateToProps)(EcecPreviewResume)
